import { type PropsWithChildren, type ReactNode } from 'react';

import { Text, Title } from '@/components/typography';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  title?: ReactNode;
  description?: ReactNode;
  showGap?: boolean;
  footer?: ReactNode;
};

const SignInPanel = ({
  className,
  title,
  description,
  children,
  showGap = false,
  footer,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        'mx-auto w-130 max-w-lg rounded-lg bg-white px-20 py-12 text-center shadow-md',
        className,
      )}
    >
      {title && (
        <div className={cn('inline-block text-center', description ? 'mb-8' : 'mb-12')}>
          <Title level={1} weight="light">
            {title}
          </Title>
        </div>
      )}
      {description && (
        <div className="-mt-4 mb-8">
          <Text variant="body2">{description}</Text>
        </div>
      )}
      <div className={cn('mx-auto flex flex-col text-left', showGap && 'gap-6')}>{children}</div>
      <div className="mt-6 flex flex-col gap-1.5 text-left">{footer}</div>
    </div>
  );
};

SignInPanel.Instructions = ({ children }: PropsWithChildren) => {
  return (
    <Text variant="body1" className="-mx-22 mb-6 text-center">
      {children}
    </Text>
  );
};

export default SignInPanel;
